export default "__VITE_ASSET__DBAEKg_6__"